<template>
<div class="navbar-menu__submenu navbar-dropdown">
    <div class="container">
        <div class="columns navbar-menu__submenu__titles is-variable is-8">
            <div class="column is-narrow no-wrap navbar-menu__submenu__titles__title">{{item.title}}</div>
            <div class="column navbar-menu__submenu__titles__subtitle" v-html="item.subtitle"></div>
        </div>
        <div class="columns is-multiline navbar-menu__submenu__submenu featured">
            <div class="column featured-column is-8" v-if="item.sub.featured.length">
                <p class="title is-6">{{item.featured_title}}</p>
                <div class="columns featured-menu is-variable is-4 is-multiline">
                    <div class="column featured-menu__item-holder is-4" v-for="featured_item, i in item.sub.featured">
                        <router-link v-if="featured_item.link.is_internal && !featured_item.link.open_in_blank" class="featured-menu__item" :to="featured_item.link.url">
                            <figure v-if="featured_item.thumb" class="featured-menu__item__image">
                                <img :src="featured_item.thumb.url" :alt="featured_item.title + '\'s thumbnail'" />
                            </figure>
                            <p class="subtitle is-7">{{featured_item.title}}</p>
                            <div class="content">{{featured_item.content}}</div>
                            <p class="featured-menu__item__action"><span class="button is-small bg-orange is-uppercase">{{featured_item.cta_label}}</span></p>
                        </router-link>
                        <a v-else class="featured-menu__item" :href="featured_item.link.url" target="_blank">
                            <figure v-if="featured_item.thumb" class="featured-menu__item__image">
                                <img :src="featured_item.thumb.url" :alt="featured_item.title + '\'s thumbnail'" />
                            </figure>
                            <p class="subtitle is-7">{{featured_item.title}}</p>
                            <div class="content">{{featured_item.content}}</div>
                            <p class="featured-menu__item__action"><span class="button is-small bg-orange is-uppercase">{{featured_item.cta_label}}</span></p>
                        </a>
                    </div>
                </div>
            </div>
            <div class="column featured-list is-offset-1 is-3" v-if="item.sub.sub.length">
                <p class="title is-4">{{item.title}}</p>
                <hr class="navbar-divider">
                <ul class="navbar-menu__submenu__submenu__submenu">
                    <li v-for="subitem, k in item.sub.sub">
                        <router-link class="navbar-menu__submenu__submenu__submenu__item" :to="subitem.url">{{subitem.label}}</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ViewBlockItemMixin from '@/components/mixins/ViewBlockItemMixin';
export default {
    name    :   'FeaturedSubmenu',
    props   :   ['item'],
    mixins  :   [ ViewBlockItemMixin ],
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/elements/FeaturedSubmenu.vue